import { createMergeReducer } from '../utils/reducer'
import { TitleIdToWatchlist } from './watchlist'

export const reducer = createMergeReducer(
  t => t.hoverWatchlist,
  {} as TitleIdToWatchlist
)
